module.exports = __webpack_public_path__ + "img/lageplan_1280.b46614a6.webp";